window.addEventListener("DOMContentLoaded", (event) => {
  const swiperIcon = document.querySelector(".swiper-text-with-icons");

  if (swiperIcon) {
    const mobileView = swiperIcon.getAttribute("data-mobile-count");
    const desktopView = swiperIcon.getAttribute("data-desktop-count");

    const textIcons = new Swiper(".swiper-text-with-icons", {
      slidesPerView: mobileView,
      spaceBetween: 20,

      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },

      breakpoints: {
        769: {
          slidesPerView: mobileView,
        },
        990: {
          slidesPerView: desktopView,
          spaceBetween: 30,
        },
      },
    });
  }
});
